import type { PaymentConfig } from 'src/interfaces/payment'
import type { State } from '../reducers/types'

/**
 * Every selector here returns a stored value by reference. Never build an object or array
 * literal in a selector — each consuming `useSelector` would re-render on every dispatch.
 * Form-shaped derivation belongs in the mappers, called under `useMemo`.
 */
export const getPaymentConfig = (state: State): PaymentConfig | null => {
  return state.paymentConfig.config
}

export const getPaymentConfigPartnerId = (state: State): string | null => {
  return state.paymentConfig.partnerId
}

export const getPaymentConfigLoading = (state: State): boolean => {
  return state.paymentConfig.loading
}

export const getPaymentConfigLoaded = (state: State): boolean => {
  return state.paymentConfig.loaded
}

export const getPaymentConfigError = (state: State): string | null => {
  return state.paymentConfig.error
}

export const getPayoutSettingsSaving = (state: State): boolean => {
  return state.paymentConfig.savingPayoutSettings
}

export const getVendorFeesSaving = (state: State): boolean => {
  return state.paymentConfig.savingVendorFees
}
